// Central app version label shown in the menu-bar footer.
// Bump the last number by one on each deployment (Alpha - v0.1.0 -> v0.1.1 -> ...).
export const APP_VERSION = "Alpha - v0.1.0";
